import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiMaximize, FiLogOut, FiUser, FiBookOpen } = FiIcons;
import supabase from '../supabase/supabase';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const isDashboard = location.pathname === '/dashboard';
  const isAccount = location.pathname === '/account';
  const isBlog = location.pathname.startsWith('/blog');

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    };
    getUser();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user || null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/');
  };

  return (
    <nav className="w-full border-b-4 border-black bg-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="p-1 border-2 border-black bg-black text-white group-hover:bg-white group-hover:text-black transition-colors">
            <SafeIcon icon={FiMaximize} className="w-6 h-6" />
          </div>
          <span className="font-black text-2xl tracking-tighter uppercase">ETERA</span>
        </Link>

        <div className="flex items-center gap-4 md:gap-8 font-black uppercase text-sm">
          <Link 
            to="/blog" 
            className={`hidden md:flex items-center gap-2 hover:text-blue-600 transition-colors ${isBlog ? 'text-blue-600' : ''}`}
          >
            <SafeIcon icon={FiBookOpen} className="w-4 h-4" /> Blog
          </Link>

          {user ? (
            <>
              {!isDashboard && (
                <Link to="/dashboard" className="hidden md:block hover:underline underline-offset-4 decoration-2">
                  My Codes
                </Link>
              )}
              <div className="flex items-center gap-2 md:gap-4">
                <Link 
                  to="/account" 
                  className={`flex items-center gap-2 border-2 border-black px-4 py-2 brutal-shadow-sm brutal-hover ${isAccount ? 'bg-black text-white' : 'bg-white text-black'}`}
                >
                  <SafeIcon icon={FiUser} className="w-4 h-4" />
                  <span className="hidden sm:inline">Account</span>
                </Link>
                <button 
                  onClick={handleSignOut}
                  className="flex items-center gap-2 border-2 border-black px-4 py-2 brutal-shadow-sm brutal-hover bg-white text-black"
                >
                  <SafeIcon icon={FiLogOut} className="w-4 h-4" />
                  <span className="hidden sm:inline">Sign Out</span>
                </button>
              </div>
            </>
          ) : (
            <>
              <a href="#how-it-works" className="hidden md:block hover:underline underline-offset-4 decoration-2">How it Works</a>
              <Link to="/login" className="border-2 border-black px-5 py-2 brutal-shadow brutal-hover bg-white">
                Login
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;